import React, { useContext } from 'react';
import LanguageContext from '../LanguageContext';
import translations from '../utils/translation';
import Menu from '../components/Menu';

const Credits = () => {
  const { language } = useContext(LanguageContext);
  const t = translations.credits;

  return (
    <div className="main-section">
      <Menu />
      <h1 className="wine-title">{t.title[language]}</h1>
      <p className="wine-title">{t.text[language]}</p>

      <div className="wine-paragraph" style={{ marginTop: '2rem' }}>
        <p>
          <strong>{t.note[language]}</strong>
        </p>

        {/* Adresse avec site web cliquable */}
        <p>
          {t.address[language].map((item, i) =>
            item.type === 'link' ? (
              <React.Fragment key={i}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.label}
                </a>
                <br />
              </React.Fragment>
            ) : (
              <React.Fragment key={i}>
                {item.value}
                <br />
              </React.Fragment>
            )
          )}
        </p>

        {/* Contact (email cliquable) */}
        <p>
          <a href={t.contact[language].url}>
            {t.contact[language].label}
          </a>
        </p>

        {/* Réseaux sociaux */}
        <p>
          {t.social[language].map((item, i) => (
            <React.Fragment key={i}>
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.label}
              </a>
              <br />
            </React.Fragment>
          ))}
        </p>

        {/* Droits */}
        <p>{t.rights[language]}</p>
      </div>
    </div>
  );
};

export default Credits;
